let moneyUnit = '$';
export const setMoneyUnit = (gameCode:string) => {
  // if (gameCode && gameCode.endsWith('demo')) {
  //   moneyUnit = '￥';
  // }
  if (gameCode && gameCode.endsWith('_cn')) {
    moneyUnit = '￥';
  } else {
    moneyUnit = '$';
  }
}

export const getMonetUnit = () => {
  return moneyUnit;
}